import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ManageYieldService {
    public url = "";
    constructor(private http: HttpClient) {
        this.url = environment.API;
    }
    

    public getMainYieldTemplates(data): Observable<any> {
        return this.http.get<any>(`${this.url}${environment.URL_MAIN_YIELD_TEMPLATES}?org_id=${data.org_id}&package_id=${data.package_id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getMainYieldTemplatesById(id): Observable<any> {
        return this.http.get<any>(`${this.url}${environment.URL_MAIN_YIELD_TEMPLATES}/${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getYieldTemplates(data): Observable<any> {
        return this.http.get<any>(`${this.url}${environment.URL_YIELD_TEMPLATES}Menu?farm_id=${data.farm_id}&package_id=${data.package_id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getYieldTemplatesById(id: string): Observable<any> {
        return this.http.get<any>(`${this.url}${environment.URL_YIELD_TEMPLATES}Menu/${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public createYieldTemplates(data): Observable<any> {
        return this.http.post<any>(`${this.url}${environment.URL_YIELD_TEMPLATES}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public updateYieldTemplates(data, id: string): Observable<any> {
        return this.http.put<any>(`${this.url}${environment.URL_YIELD_TEMPLATES}/${id}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
}